<template>
	<div :id="textID" class="Service">
		<div class="Service__image">
			<img :src="require(`@/assets/images/services/${image}.jpg`)" :alt="title">
		</div>
		<div class="Service__content">
			<div>
				<h2>{{ title }}</h2>
			</div>
			<div>
				<p>{{ text }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Service',
	props: {
		title: String,
		imgID: Number,
		text: String,
		textID: String,
		image: String
	},
	mounted() {
		this.scrollTo(this.$route.params)
	},
	methods: {
		scrollTo(params) {
			if(params.hasOwnProperty('serviceID')) {
				const { serviceID } = params
				const element = document.getElementById(serviceID);
				element.scrollIntoView({ block: 'center' });
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.Service {
	margin-bottom: 50px;

	@media screen and (min-width: 1440px) {
		position: relative;
		margin: 0;
		overflow: hidden;
	}

	&__image {
		display: flex;
		justify-content: center;

		@media screen and (min-width: 1440px) {
			height: 500px;
		}
		
		img {
			width: 90%;
			height: 100%;
			@include box-shadow(0px 4px 5px -6px rgba(0,0,0,0.75));
			border-radius: 5px;
			border: 2px solid #fff;

			@media screen and (min-width: 768px) {
				width: 70%;
			}
			@media screen and (min-width: 1440px) {
				width: 100%;
				background-size: cover;
				background-position: center;
				border-radius: 0;
				@include transition(0.2);
				border: none;
			}
		}
	}

	&__content {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-top: 10px;
		@include transition(0.2);

		@media screen and (min-width: 1440px) {
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			margin: 0;
			flex-wrap: nowrap;
			opacity: 0;
			visibility: hidden;
		}

		div {
			padding: 10px 20px;
			text-align: center;
			width: 100%;

			@media screen and (min-width: 1440px) {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 100%;
			}

			&:first-child {
				@media screen and (min-width: 1440px) {
					width: 40%;
				}
			}

			&:last-child {
				padding: 10px 30px;

				@media screen and (min-width: 768px) {
					width: 70%;
				}
				@media screen and (min-width: 1440px) {
					width: 60%;
					max-width: 700px;
				}
			}

			h2 {
				color: white;
				text-transform: uppercase;
				font-weight: 600;
				margin: 0;

				@media screen and (min-width: 1440px) {
					font-size: 2.5em;
				}
			}

			p {
				color: white;
				font-size: 1em;
				margin: 0;
				font-weight: 300;
				text-align: justify;
				line-height: 23px;

				@media screen and (min-width: 1440px) {
					font-size: 1.3em;
					font-weight: 400;
					line-height: 28px;
				}
			}
		}
	}

	&:nth-child(2n) {
		.Service__content {
			flex-direction: row-reverse;
		}
	}

	&:hover {
		@media screen and (min-width: 1440px) {
			.Service__image {
				img {
					filter: blur(2px);
					transform: scale(1.1);
				}
			}
			.Service__content {
				background: rgba(0, 0, 0, 0.4);
				opacity: 1;
				visibility: visible;
			}
		}
	}
}

</style>

